import Base_ModuleProcessor from '@shared/Framework/BaseClass/Base_ModuleProcessor';

class IntranetBase_ModuleProcessor extends Base_ModuleProcessor {

    constructor() {
        super();
    }
}

export default IntranetBase_ModuleProcessor;